module.exports = __webpack_public_path__ + "img/8cb858e.jpg";